<template lang="pug">
v-container(fluid)
  v-row(class="pt-3" no-gutters justify="space-between")
    v-col(cols="9")
      v-text-field(
        :label="$t('Common.name')"
        v-model="page.name"
        color="blue darken-4"
        required
        outlined
        :rules="[required, title_length]"
      )
    v-col(cols="2")
      v-switch(
        v-model="page.published"
        label="Active"
        :true-value=1
        :false-value=0
        inset
        ripple=false
        color="indigo accent-1"
      )
  v-row(no-gutters)
    v-col(cols="9" class="pt-0 mt-0")
      v-text-field(
        :label="$t('Website.Common.meta_title')"
        v-model="page.meta_title"
        :placeholder="test"
        color="blue darken-4"
        outlined
        :rules="[meta_title_length]"
        class=""
      )
  v-row(no-gutters)
    v-col(cols="9" class="pt-0 mt-0")
      v-textarea(
        :label="$t('Website.Common.meta_description')"
        v-model="page.meta_description"
        color="blue darken-4"
        outlined
        :rules="[meta_description_length]"
        class=""
        rows="4"
      )
  v-row(no-gutters)
    v-col(cols="2")
      v-row(no-gutters)
        v-col(align="right" cols="12")
          v-img(
            v-if="page.background_image === null"
            :src="require('@/assets/images/placeholder-image.jpg')"
            width="100%"
          )
          helper-img-file-preview(
            v-if="typeof page.background_image == 'object'"
            :file="page.background_image"
            style="max-width: 200px; max-height: 120px"
          )
          v-img(v-else :src="path(page.background_image)" max-width="200" max-height="120")
    v-col(cols="6" class="ml-4")
      div(class="pl-8")
        span {{ $t('Website.Common.background_image') }}
      div
        v-file-input(accept="image/*" v-model="page.background_image")
</template>
<script>
export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required: (v) => !!v || this.$t('Common.required'),
      title_length: (v) => (v && v.length <= 25) || this.$t('Common.max25'),
      meta_title_length: (v) => !v || v.length <= 60 || this.$t('Common.max60'),
      meta_description_length: (v) => !v || v.length <= 160 || this.$t('Common.max160'),
    };
  },
};
</script>
